<template>
  <div style="width: 25%;">
    <div style="width:100%  display: flex;" class="two">
      <span>成单状态</span>
      <div id="two" style="width:100%; height:400px
      ">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    list2: Array
  },
  name: "",
  data () {
    return {

    }
  },
  mounted () {
    this.initBie()
  },
  methods: {
    initBie () {
      const chartDom = document.getElementById('two');
      const myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#fc8452',
          '#9a60b4',],
        title: {
          text: '',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: this.list2,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      window.onresize = function () {
        myChart.resize();
      }
      option && myChart.setOption(option);

    }
  },
  watch: {
    list2: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income1.vue